import * as yup from 'yup'

// Messages are translation keys (see src/i18n/locales); ContactForm renders them with t()
export const contactSchema = yup.object().shape({
    name: yup.string().required('contact.errors.name'),
    email: yup.string().email('contact.errors.emailInvalid').required('contact.errors.email'),
    number: yup.string().required('contact.errors.phone'),
    enterprise: yup.string().required('contact.errors.enterprise'),
    subject: yup.string().required('contact.errors.subject'),
    message: yup.string().required('contact.errors.message'),
})
